/**
 * Get status info for an assignment
 */
export const getStatusInfo = (assignment) => {
  const submissionStatus = assignment.submission?.status;
  if (submissionStatus === "submitted") {
    return { label: "Completed", className: "status-completed" };
  }
  if (submissionStatus === "draft" || assignment.status === "in_progress") {
    return { label: "In Progress", className: "status-progress" };
  }
  return { label: "Not Started", className: "status-pending" };
};

/**
 * Group rating questions by linked action
 */
export const groupByAction = (questions) => {
  const actionMap = new Map();

  questions.forEach((q) => {
    if (q.linkedAction?.actionId) {
      const key = q.linkedAction.actionId;
      if (!actionMap.has(key)) {
        actionMap.set(key, {
          action: q.linkedAction,
          questions: [],
          totalScore: 0,
          count: 0,
        });
      }
      const entry = actionMap.get(key);
      entry.questions.push(q);
      if (q.stats?.average) {
        entry.totalScore += q.stats.average;
        entry.count++;
      }
    }
  });

  // Calculate average for each action
  actionMap.forEach((entry) => {
    entry.average = entry.count > 0 ? entry.totalScore / entry.count : 0;
  });

  return Array.from(actionMap.values());
};

/**
 * Get question data (handle both inline and referenced questions)
 */
export const getQuestionData = (q) => {
  if (q.inlineQuestion) {
    return q.inlineQuestion;
  }
  if (q.questionId && typeof q.questionId === "object") {
    return q.questionId;
  }
  return q;
};

/**
 * Calculate form progress percentage
 */
export const calculateProgress = (answers, totalQuestions) => {
  if (totalQuestions === 0) return 0;
  const answeredCount = Object.keys(answers).filter((k) => {
    const val = answers[k];
    return val !== null && val !== undefined && val !== "";
  }).length;
  return Math.round((answeredCount / totalQuestions) * 100);
};

/**
 * Status labels for diagnostic requests
 */
export const REQUEST_STATUS_LABELS = {
  pending_approval: { text: "Pending Approval", color: "#d97706", bg: "#fef3c7" },
  approved: { text: "Approved", color: "#16a34a", bg: "#dcfce7" },
  rejected: { text: "Rejected", color: "#dc2626", bg: "#fee2e2" },
};
